/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  InboundFaxListResponseDto,
  InboundFaxUrlResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InboundFaxListResponseDtoFromJSON,
    InboundFaxListResponseDtoToJSON,
    InboundFaxUrlResponseDtoFromJSON,
    InboundFaxUrlResponseDtoToJSON,
} from '../models/index';

export interface GetCurrentPatientFaxUrlRequest {
    id: string;
}

export interface ListCurrentPatientFaxesRequest {
    page?: number;
    pageSize?: number;
}

export interface ListPatientFaxesRequest {
    patientId: string;
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class FaxesPatientApi extends runtime.BaseAPI {

    /**
     * Patient-only. Returns a 15-minute signed GCS URL with inline PDF response hints for a fax assigned to the authenticated patient. Returns 404 if the fax is not assigned to this patient.
     * Get signed PDF URL for a fax assigned to the current patient
     */
    async getCurrentPatientFaxUrlRaw(requestParameters: GetCurrentPatientFaxUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxUrlResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCurrentPatientFaxUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/me/faxes/{id}/url`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxUrlResponseDtoFromJSON(jsonValue));
    }

    /**
     * Patient-only. Returns a 15-minute signed GCS URL with inline PDF response hints for a fax assigned to the authenticated patient. Returns 404 if the fax is not assigned to this patient.
     * Get signed PDF URL for a fax assigned to the current patient
     */
    async getCurrentPatientFaxUrl(requestParameters: GetCurrentPatientFaxUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxUrlResponseDto> {
        const response = await this.getCurrentPatientFaxUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patient-only endpoint for the Diagnostics tab. Returns inbound faxes assigned to the authenticated patient.
     * List inbound faxes assigned to the current patient
     */
    async listCurrentPatientFaxesRaw(requestParameters: ListCurrentPatientFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/me/faxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Patient-only endpoint for the Diagnostics tab. Returns inbound faxes assigned to the authenticated patient.
     * List inbound faxes assigned to the current patient
     */
    async listCurrentPatientFaxes(requestParameters: ListCurrentPatientFaxesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxListResponseDto> {
        const response = await this.listCurrentPatientFaxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns inbound faxes assigned to a patient for the provider Diagnostics tab. Results are scoped to the provider\'s current practice.
     * List inbound faxes assigned to a patient
     */
    async listPatientFaxesRaw(requestParameters: ListPatientFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxListResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling listPatientFaxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/{patientId}/faxes`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns inbound faxes assigned to a patient for the provider Diagnostics tab. Results are scoped to the provider\'s current practice.
     * List inbound faxes assigned to a patient
     */
    async listPatientFaxes(requestParameters: ListPatientFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxListResponseDto> {
        const response = await this.listPatientFaxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
